import { render, staticRenderFns } from "./trial-explainer.vue?vue&type=template&id=03843548&scoped=true&"
import script from "./trial-explainer.vue?vue&type=script&lang=js&"
export * from "./trial-explainer.vue?vue&type=script&lang=js&"
import style0 from "./trial-explainer.vue?vue&type=style&index=0&id=03843548&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03843548",
  null
  
)

export default component.exports